import { Nullable } from 'utils/types';
import { EndowmentField } from '../Endowment';
import { InvestmentField } from '../Investment';
import { RepaymentStrategyField, PropertyField } from '../RepaymentStrategy';

export interface FieldPayload {
  field: RepaymentStrategyField;
  payload?: any;
}

export interface State {
  [RepaymentStrategyField.HaveEndownments]: boolean;
  [RepaymentStrategyField.HaveInvestments]: boolean;
  [RepaymentStrategyField.HaveSaleOfAnotherProperty]: boolean;
  [RepaymentStrategyField.HaveSaleOfPropertyAndDownsizing]: boolean;
  [RepaymentStrategyField.HaveOther]: boolean;

  [RepaymentStrategyField.RepaymentValueOfHaveSaleOfAnotherProperty]: number;
  [RepaymentStrategyField.RepaymentValueOfSaleOfPropertyAndDownsizing]: number;
  [RepaymentStrategyField.RepaymentValueOfHaveEndownments]: number;
  [RepaymentStrategyField.RepaymentValueOfHaveInvestments]: number;
  [RepaymentStrategyField.RepaymentValueOfHaveOther]: number;

  [RepaymentStrategyField.TotalAmountToBeRepaid]: number;
  [RepaymentStrategyField.RepaymentValueTotalCalculated]: number;
  [RepaymentStrategyField.DetailsForOther]: string;
  properties: Array<{
    [PropertyField.FlatNumber]: Nullable<string>;
    [PropertyField.BuildingNumber]: Nullable<string>;
    [PropertyField.BuildingName]: Nullable<string>;
    [PropertyField.Street]: Nullable<string>;
    [PropertyField.City]: Nullable<string>;
    [PropertyField.County]: Nullable<string>;
    [PropertyField.PostCode]: Nullable<string>;
    [PropertyField.CurrentMortgageBalance]: Nullable<number>;
    [PropertyField.DateOfPurchase]: Nullable<string>;
    [PropertyField.PurchasePrice]: Nullable<number>;
  }>;

  endowments: Array<{
    [EndowmentField.Provider]: Nullable<string>;
    [EndowmentField.ExpectedMaturityDate]: Nullable<string>;
    [EndowmentField.CurrentFundValue]: Nullable<number>;
    [EndowmentField.MonthlyContribution]: Nullable<number>;
  }>;

  investments: Array<{
    [InvestmentField.Provider]: Nullable<string>;
    [InvestmentField.ExpectedMaturityDate]: Nullable<string>;
    [InvestmentField.CurrentFundValue]: Nullable<number>;
    [InvestmentField.MonthlyContribution]: Nullable<number>;
  }>;
}
export interface Action<TPayload = unknown> {
  type: Actions;
  payload: TPayload;
}

export enum Actions {
  // Getting data
  SET_GETTING_DATA_START = 'CM/REPAYMENT_STRATEGY/GET/START',
  SET_GETTING_DATA_FINISH = 'CM/REPAYMENT_STRATEGY/GET/FINISH',
  SET_GETTING_DATA_ERROR = 'CM/REPAYMENT_STRATEGY/GET/ERROR',

  // Updating repayment strategy
  SET_UPDATING_DATA_START = 'CM/REPAYMENT_STRATEGY/UPDATE/START',
  SET_UPDATING_DATA_FINISH = 'CM/REPAYMENT_STRATEGY/UPDATE/FINISH',
  SET_UPDATING_DATA_ERROR = 'CM/REPAYMENT_STRATEGY/UPDATE/ERROR',

  SET_PROPERTIES_FINISH = 'CM/REPAYMENT_STRATEGY/SET_PROPERTIES/FINISH',
  ADD_PROPERTY = 'CM/REPAYMENT_STRATEGY/PROPERTIES/ADD_SINGLE',
  REMOVE_PROPERTY = 'CM/REPAYMENT_STRATEGY/PROPERTIES/REMOVE_SINGLE',

  SET_ENDOWMENTS_FINISH = 'CM/REPAYMENT_STRATEGY/SET_ENDOWMENTS/FINISH',
  ADD_ENDOWMENT = 'CM/REPAYMENT_STRATEGY/ENDOWMENTS/ADD_SINGLE',
  REMOVE_ENDOWMENT = 'CM/REPAYMENT_STRATEGY/ENDOWMENTS/REMOVE_SINGLE',

  SET_INVESTMENTS_FINISH = 'CM/REPAYMENT_STRATEGY/SET_INVESTMENTS/FINISH',
  ADD_INVESTMENT = 'CM/REPAYMENT_STRATEGY/INVESTMENTS/ADD_SINGLE',
  REMOVE_INVESTMENT = 'CM/REPAYMENT_STRATEGY/INVESTMENTS/REMOVE_SINGLE',
}

export const createState = (): State => ({
  [RepaymentStrategyField.HaveEndownments]: false,
  [RepaymentStrategyField.HaveInvestments]: false,
  [RepaymentStrategyField.HaveOther]: false,
  [RepaymentStrategyField.HaveSaleOfAnotherProperty]: false,
  [RepaymentStrategyField.HaveSaleOfPropertyAndDownsizing]: false,

  [RepaymentStrategyField.RepaymentValueOfHaveSaleOfAnotherProperty]: 0,
  [RepaymentStrategyField.RepaymentValueOfSaleOfPropertyAndDownsizing]: 0,
  [RepaymentStrategyField.RepaymentValueOfHaveEndownments]: 0,
  [RepaymentStrategyField.RepaymentValueOfHaveInvestments]: 0,
  [RepaymentStrategyField.RepaymentValueOfHaveOther]: 0,
  [RepaymentStrategyField.TotalAmountToBeRepaid]: 0,
  [RepaymentStrategyField.RepaymentValueTotalCalculated]: 0,
  [RepaymentStrategyField.DetailsForOther]: '',
  properties: [],

  endowments: [],

  investments: [],
});
